<template>
  <div class="container">
    <div class="row">
      <div class="col-md-3 col-lg-2 col-xl-2 navbar-collapse sidebar">
        <div class="sidebar-header">
          <a class="vik-brand" href="#">
            <img src="@/assets/logo.svg" alt />
          </a>
          <div id="dismissSidebar">
            <svg viewBox="0 0 24 24" width="24" height="24" xmlns="http://www.w3.org/2000/svg"
              class="SideNav__closeIcon__56eIa" stroke="currentColor" tabindex="0">
              <path d="M1 1L23 23M1 23L23 1" />
            </svg>
          </div>
        </div>

        <div class="category-list">
          <h2>Templates</h2>
          <p class="not-available" style="color: #8e8e8e; margin-top: 15px">
            <i>no templates</i>
          </p>
        </div>
      </div>
      <div class="col-md-8 col-lg-8 col-xl-8">
        <div class="content">
          <div class="content new-item">
            <h2 class="block-title" style="margin-bottom: 30px">New task</h2>
            <el-form ref="testform" label-position="top" :model="form" @submit.native.prevent>
              <el-form-item prop="task_name" label="Task name" :rules="[
                {
                  required: true,
                  message: 'Please input task name',
                  trigger: 'blur',
                },
              ]">
                <input name="task_name" type="text" v-model="form.task_name" class="form-control"
                  placeholder="For example: my server ports scan" />
              </el-form-item>
              <!-- <el-form-item>
                <input type="checkbox" class="switch-input" id="Switch2" v-model="showAssetsTree" />
                <label class="switch-label" for="Switch2">Use assets</label>
              </el-form-item> -->

              <!-- <el-form-item label="Assets" prop="assets" :rules="[{ validator: validateTargets, trigger: 'blur' }]"
                v-if="showAssetsTree">
                <div class="form-group">
                  <div v-if="!preloadedTargets">
                   
                    <div class="form-group-inline">
                      <div class="switch-box">
                        <input type="checkbox" class="switch-input" id="Switch1" v-model="allTargetsChecked"
                          v-if="preloadedTargets == false" />
                        <label class="switch-label" for="Switch1">Use all assets</label>
                      </div>
                    </div>

                    <div class="form-group-inline" v-if="allTargetsChecked == false">
                      <div class="switch-box">
                        <input type="checkbox" class="switch-input" id="TopLevels" v-model="topLevelFilter" />
                        <label class="switch-label" for="TopLevels">Show hosts</label>
                      </div>
                    </div>
                  </div>
                  <div v-if="!allTargetsChecked">
                    <div class="search-group" v-if="!preloadedTargets">
                      <input type="text" class="form-control" v-model="targetsFilter" placeholder="filter" />
                      <div class="input-icon">
                        <i class="vik vik-search"></i>
                      </div>
                    </div>

                    <div v-if="targetsLoading" width="300" style="margin-top: 10px">
                      <vcl-list :width="360" :height="120"></vcl-list>
                    </div>
                    <AssetsTree v-else :assets="formatedTargets" :showAssets="topLevelFilter" show-checkbox
                      :ref="`assetsTree`"></AssetsTree>
                  </div>
                </div>
              </el-form-item> -->
              <el-form-item label="Atoms" prop="atoms" :rules="[{ validator: validateAtoms, trigger: 'blur' }]">
                <div class="atom-tree">
                  <ul>
                    <li class="atom-tree-item" :key="i" v-for="(config, i) in form.atoms">
                      <div class="num">{{ i + 1 }}.</div>
                      <div class="atom-tree-item-cont">
                        <div class="choose-atom">
                          <el-select v-model="form.atoms[i].atom_id" remote filterable
                            :remote-method="onAtomFilterQueryChange" @change="onAtomSelected(i)"
                            placeholder="Choose an atom">
                            <el-option v-for="item in scripts_list" :key="item.value" :value="item.value"
                              :label="item.label">{{ item.label }}</el-option>
                          </el-select>
                        </div>

                        <div class="control-tree-item">
                          <div class="btn-line">
                            <!--
                        <button type="button" class="btn btn-sm btn-icon">
                          <i class="vik vik-arrows-up-down"></i>
                        </button>
                            -->
                            <button type="button" class="btn btn-sm btn-icon del" v-if="form.atoms.length > 1"
                              @click="removeAtomByIndex(i)">
                              <i class="vik vik-delete"></i>
                            </button>
                          </div>
                        </div>

                        <div class="item-cont-group" v-if="varsEnabled[i]">
                          <h4 class="tree-title-group">Variables</h4>

                          <div class="variables-group">
                            <div v-bind:key="v" v-for="(v, idx) in varsExtracted[i]">
                              <h5 class="tree-title-variables">{{ v }}</h5>

                              <div class="choose-var">
                                <el-cascader :options="dataComputed" @change="onCascadeChange(i, idx, v)" v-model="form.atoms[i].variables[idx].var_type
                                  "></el-cascader>
                              </div>

                              <div class="control-var-item" v-if="form.atoms[i].variables[idx].var_options">
                                <el-input v-if="form.atoms[i].variables[idx].var_options == 'inline/strings'"
                                  type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="One record per line"
                                  v-model="form.atoms[i].variables[idx].var_data" ></el-input>
                                <div class="item-cont-group" v-if="form.atoms[i].variables[idx].var_options == 'generator/chars'">
                                  <div class="form-group">
                                    <label >Charset</label>
                                    <div class="el-input">
                                      <input type="text" autocomplete="off" class="el-input__inner" v-model="form.atoms[i].variables[idx].var_options_data.charset"> 
                                    </div>

                                    <el-input 
                                      ></el-input>
                                  </div>
                                  <div class="form-line">
                                    <div class="form-group">
                                      <label >Min length</label>
                                      <el-input-number v-model="form.atoms[i].variables[idx].var_options_data.min_length" :min="1"
                                        :max="500"></el-input-number>
                                    </div>
                                    <div class="form-group">
                                      <label >Max length</label>
                                      <el-input-number v-model="form.atoms[i].variables[idx].var_options_data.max_length" :min="1"
                                        :max="500"></el-input-number>
                                    </div>
                                  </div>
                                </div>
                                <div class="item-cont-group" v-show="form.atoms[i].variables[idx].var_options == 'generator/randomstring'">
                                  <div class="form-group">
                                    <label >Charset</label>
                                    <div class="el-input">
                                      <input type="text" autocomplete="off" class="el-input__inner" v-model="form.atoms[i].variables[idx].var_options_data.charset"> 
                                    </div>
                                  </div>
                                  <div class="form-line">
                                    <div class="form-group">
                                      <label>Min length</label>
                                      <el-input-number v-model="form.atoms[i].variables[idx].var_options_data.min_length" :min="1"
                                        :max="500"></el-input-number>
                                    </div>
                                    <div class="form-group">
                                      <label for="">Max length</label>
                                      <el-input-number v-model="form.atoms[i].variables[idx].var_options_data.max_length" :min="1"
                                        :max="500"></el-input-number>
                                    </div>
                                  </div>
                                  <div class="form-group">
                                    <label for="">Quantity</label>
                                    <el-input-number v-model="form.atoms[i].variables[idx].var_options_data.quantity" :min="1"
                                      :max="1000000"></el-input-number>
                                  </div>
                                </div>
                                <div class="item-cont-group" v-if="form.atoms[i].variables[idx].var_options == 'generator/numbers'">
                                  <div class="form-line">
                                    <div class="form-group">
                                      <label for="">From</label>
                                      <el-input-number v-model="form.atoms[i].variables[idx].var_options_data.min" :min="1"
                                        :max="500"></el-input-number>
                                    </div>
                                    <div class="form-group">
                                      <label for="">To</label>
                                      <el-input-number v-model="form.atoms[i].variables[idx].var_options_data.max" :min="1"
                                        :max="500"></el-input-number>
                                    </div>
                                  </div>
                                  <div class="form-group">
                                    <label for="">Step</label>
                                    <el-input-number v-model="form.atoms[i].variables[idx].var_options_data.step" :min="1"
                                      :max="1000000"></el-input-number>
                                  </div>
                                </div>
                              </div>




                              <!-- <div class="control-var-item" v-if="form.atoms[i].variables[idx].var_has_options
                                ">
                                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
                                  placeholder="One record per line" v-model="form.atoms[i].variables[idx].var_data
                                    "></el-input>
                              </div>
                              {{ form.atoms[i].variables[idx] }} -->
                              
                            </div>
                          </div>
                        </div>
                        <div class="item-cont-group">
                          <h4 class="tree-title-group">Threads</h4>
                          <el-input-number v-model="form.atoms[i].threads" :min="1" :max="150"></el-input-number>
                        </div>

                        <div class="item-cont-group" v-if="settingsEnabled[i]">
                          <el-form-item label="Settings">
                            <div v-bind:key="idx" v-for="(v, idx) in settingsExtracted[i]" class="mrg">
                              <div class="block33">
                                <el-checkbox v-if="v.view == 'checkbox'" v-model="form.atoms[i].settings[idx].value">{{
                                  v.title }}</el-checkbox>
                                <div v-if="v.view == 'multiselect'">
                                  <h4 class="setting-title">{{ v.title }}</h4>
                                  <el-select v-model="form.atoms[i].settings[idx].value
                                    " filterable multiple allow-create :placeholder="form.atoms[i].settings[idx].title
    ">
                                    <el-option v-for="item in v.value" :value="item" :key="item">{{ item }}</el-option>
                                  </el-select>
                                </div>
                                <div v-if="v.view == 'string'">
                                  <h4 class="setting-title">{{ v.title }}</h4>
                                  <el-input v-model="form.atoms[i].settings[idx].value
                                    "></el-input>
                                </div>
                                <br />
                              </div>
                            </div>
                          </el-form-item>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </el-form-item>

              <el-form-item label="Triggers">
                <el-select v-model="form.triggers" filterable multiple default-first-option>
                  <!-- <el-option
                                        v-for="val in item.value"
                                        :value="val"
                                        :key="val"
                                        :label="val"
                                        >{{ val }}</el-option
                                      > -->
                  <el-option :value="`tg`" :key="`tg`" :label="`telega =)`">tel</el-option>
                </el-select>
              </el-form-item>
            </el-form>

            <div class="form-group">
              <div class="btn-line">
                <button type="button" class="btn btn-primary" @click="addAtom">
                  <i class="vik vik-plus"></i>Add script
                </button>
                <button type="button" class="btn btn-success" @click="save">
                  <i class="vik vik-save"></i>Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { bus } from "@/bus.js";
import * as utils from "@/utils.js";
// import $ from "jquery";
import AssetsTree from "@/components/internal/AssetsTree";
import _ from "lodash";
// import { SelfBuildingSquareSpinner } from "epic-spinners";
import { getScripts, getFiles, newTask } from "@/api.js";
import { VclList, VclCode } from "vue-content-loading";
export default {
  components: { AssetsTree, VclCode, VclList },
  data() {
    return {
      preloadedTargets: false,
      model1: "",
      formatedTargets: [],
      data2: [
        {
          title: "a.com",
        },
        {
          title: "b.com",
          expand: false,
          children: [
            {
              title: "xxx.b.com",
            },
          ],
        },
      ],
      targetsFilter: "",
      atoms: [],
      lists: [],
      varsEnabled: [false],
      settingsEnabled: [false],
      varsExtracted: [],
      settingsExtracted: [],
      targets_source: [],
      allTargetsChecked: false,
      preloadedTargets: false,
      atomFilterLoading: false,
      showAssetsTree: false,
      form: {
        task_name: "",
        assets: [],
        atoms: [{ id: "", variables: [], settings: [], threads: 1 }],
        triggers: [],
      },
      rules: {
        task_name: [
          {
            required: true,
            message: "Please input task name",
            trigger: "blur",
          },
          { min: 1, message: "Length should be 3 to 5", trigger: "blur" },
        ],
      },
      filterMethod(query, item) {
        return item.key.toLowerCase().indexOf(query.toLowerCase()) > -1;
      },
      loadAssets: false,
      targetsLoading: true,
      dt: {},
      varCascade: [],
    };
  },
  mounted() {
    this.getAtoms();
    this.getLists();
    this.checkHash();
    this.loadTargets();
  },
  watch: {
    targetsFilter(v) {
      this.loadTargets();
    },
  },
  methods: {
    validateTargets(rule, value, callback) {
      if (!value || value.length < 1) {
        return callback(new Error("Choose targets"));
      }
      callback();
    },
    validateAtoms(rule, value, callback) {
      for (var i of value){
        if (i.atom_id.length<1) return callback(new Error("Choose atoms"));
      }
      callback();
    },
    onAtomFilterQueryChange(query) {
      this.atomFilterLoading = true;
      this.getAtoms(query);
      this.atomFilterLoading = false;
    },
    checkHash() {
      if (this.$route.hash) {
        var that = this;
        var lochash = this.$route.hash.substring(1);
        var params = lochash
          .split("&")
          .map((v) => v.split("="))
          .reduce((pre, [key, value]) => ({ ...pre, [key]: value }), {});
        if (params.selectedTargets) {
          this.preloadedTargets = true;
          let targetsSlice = params.selectedTargets.split(",");
          var targetsData = [];
          let index = 0;
          let t = [];
          _.forEach(targetsSlice, function (target) {
            t.push({
              title: target,
              checked: false,
              expand: false,
              children: [],
            });
          });
          that.formatedTargets = t;
        }
        if (params.taskName) {
          that.form.task_name = unescape(params.taskName);
        }
      } else {
      }
    },
    addAtom() {
      this.form.atoms.push({
        hash: "",
        variables: [],
        settings: [],
        threads: 1,
      });
    },
    removeAtomByIndex(index) {
      if (index > -1) {
        this.form.atoms.splice(index, 1);
      }
      // this.form.atoms.splice(-1, 1);
    },
    renderTargetsForm(targetsData) {
      /*
      let that = this;
      if (that.dt != null) {
        jQuery("#example").DataTable().destroy();
      }
      that.dt = jQuery("#example").DataTable({
        data: targetsData,
        deferRender: true,
        scrollY: 200,
        scrollCollapse: true,
        scroller: true,
        searching: false, // todo: remove =)
        createdRow: function (row, data, dataIndex) {
          jQuery(row).addClass("el-table__row");
        },
        columnDefs: [
          {
            targets: 0,
            checkboxes: {
              selectRow: true,
            },
          },
        ],
        select: {
          style: "multi",
        },
        order: [[1, "asc"]],
      });
      */
    },
    submitForm(formName) {
      let that = this;
      this.form.assets = { scopes: [], assets: [], all: false };
      if (this.showAssetsTree) {
        if (this.allTargetsChecked) {
          that.form.assets.all = true;
        } else {
          this.form.assets = this.$refs["assetsTree"].getCheckedValues();
        }
      }
      // todo: add atoms validation
      this.$refs[formName].validate((valid) => {
        if (valid) {  
          newTask(this.form)
            .then((data) => {
              that.$router.push({
                name: "SingleTask",
                params: { id: "" + data.TaskID },
              });
            })
            .catch(function (err) {
              console.log(err);
            });
        } else {
          utils.showError(
            this,
            "Error",
            "Failed to load tags from marketplace: " + tags.error
          );
        }

        // utils.sendPost("/api/tasks/save/",).then((resp) => {
        //   if (resp.error == null) {
        //     bus.$emit("refresh-tasks", true);

        //   } else {
        //     alert(resp.error);
        //   }
        //
        // } else {
        //   console.log("error submit!!");
        //   return false;
        // }
      });
    },
    onCascadeChange(hash, var_id, var_name) {
      console.log('onCascadeChange')
      this.form.atoms[hash].variables[var_id].var_name = var_name;
      let d = this.form.atoms[hash].variables[var_id].var_type;
      switch (d[0]) {
        case "inline":
          switch (d[1]) {
            case "list":
              var cloned = Object.assign({}, this.form.atoms[hash]);
              cloned.variables[var_id].var_has_options = true;
              cloned.variables[var_id].var_options = "inline/strings"
              this.$set(this.form.atoms, hash, cloned);
              break;

            default:
              var cloned = Object.assign({}, this.form.atoms[hash]);
              cloned.variables[var_id].var_has_options = false;
              this.$set(this.form.atoms, hash, cloned);
          }
          break;

        default:
          // hide var parameters
          var cloned = Object.assign({}, this.form.atoms[hash]);
          cloned.variables[var_id].var_has_options = false;
          this.$set(this.form.atoms, hash, cloned);

        case "generator":
          switch (d[1]) {
            case "numbers":
              var cloned = Object.assign({}, this.form.atoms[hash]);
              cloned.variables[var_id].var_has_options = true;
              cloned.variables[var_id].var_options = "generator/numbers"
              cloned.variables[var_id].var_options_data = {
                step: 1,
                min: 100,
                max: 1000,
              };
              this.$set(this.form.atoms, hash, cloned);
              break;

            case "chars":
              var cloned = Object.assign({}, this.form.atoms[hash]);
              cloned.variables[var_id].var_has_options = true;
              cloned.variables[var_id].var_options = "generator/chars"
              cloned.variables[var_id].var_options_data = {
                charset: "0123456789abcdefghijklmnopqrstuvwxyz",
                min_length: 2,
                max_length: 3,
              }
              this.$set(this.form.atoms, hash, cloned);

              break;
            case "randomstring":
              var cloned = Object.assign({}, this.form.atoms[hash]);
              cloned.variables[var_id].var_has_options = true;
              cloned.variables[var_id].var_options = "generator/randomstring"
              cloned.variables[var_id].var_options_data = {
                charset: "0123456789abcdefghijklmnopqrstuvwxyz",
                min_length: 5,
                max_length: 10,
                quantity: 10,
              }
              this.$set(this.form.atoms, hash, cloned);

              break;
          }

      }
    },
    extractVars(code, start_template, end_template) {
      var re = /{\{[^}\]\[\{}](\w+)\}\}/g;
      let v = code.match(re);
      if (v)
        return v
          .map((res) => res.replace(/{|}|[|]/g, ""))
          .filter((v, i, a) => a.indexOf(v) === i);
      else return [];
    },
    onAtomSelected(id) {
      console.log("on select", id);
      let atom = this.getAtomInfo(this.form.atoms[id].atom_id);
      let extractedVars = this.extractVars(atom.code);
      this.form.atoms[id].settings = []; // reset
      this.varsEnabled[id] = false; // reset
      this.varsExtracted[id] = []; // reset
      this.settingsEnabled[id] = false; // reset
      this.settingsExtracted[id] = []; // reset
      if (extractedVars != null && extractedVars.length > 0) {
        this.varsEnabled[id] = true;
        this.varsExtracted[id] = extractedVars;
        for (let i in this.varsExtracted[id]) {
          var var_name = this.varsExtracted[id][i];
          this.form.atoms[id].variables.push({
            var_name: "",
            var_type: [],
            var_data: "",
            var_has_options: false,
          });
        }
      } else {
        this.varsEnabled[id] = false;
        this.varsExtracted[id] = [];
      }
      if (atom.settings.length > 0) {
        try {
          let settings = atom.settings;
          if (settings && settings.length > 0) {
            this.settingsEnabled[id] = true;
            this.settingsExtracted[id] = settings;
            for (let i in settings) {
              let item = settings[i];
              this.form.atoms[id].settings.push({
                name: item.name,
                title: item.title,
                view: item.view,
                value: item.value,
              });
            }
          }
        } catch (e) {
          console.log(e);
        }
      }
      // this.form.atoms[id].title = atom.title;
    },
    getAtomInfo(id) {
      for (var i in this.atoms) {
        if (this.atoms[i].atom_id == id) {
          return this.atoms[i];
        }
      }
      return null;
    },
    charsetChanged(a,b,c){
      console.log(a,b,c)
    },
    getAtoms(query) {
      getScripts((query = query ? query : ""), 1, 50)
        .then((data) => {
          this.atoms = data.Records;
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    loadTargets() {
      if (this.preloadedTargets) {
        return;
      }
      this.targetsLoading = true;
      let that = this;
      that.targets = [];
      that.targets_source = [];
      utils
        .$get(
          `/api/assets/tree/?assets=${this.topLevelFilter.toString()}&q=${this.computedTargetsFilter
          }&limit=50000`
        )
        .then((data) => {
          // var scopes = Object.assign([], data.scopes);
          data.scopes.forEach((scope, index) => {
            scope.assets = [];
            scope.id = scope.id;
            scope.type = "scope";
            scope.expand = false;
            scope.checked = false;
          });
          data.assets.forEach((asset, index) => {
            for (let i in data.scopes) {
              if (data.scopes[i].id === asset.scope_id) {
                // expand asset props...
                asset.id = asset.id;
                asset.type = "asset";
                asset.checked = false;
                asset.expand = false;
                data.scopes[i].assets.push(asset);
              }
            }
          });
          that.formatedTargets = Object.assign([], data.scopes);
          that.targetsLoading = false;
          console.timeEnd("loadTargets");
          // that.renderTargetsForm(targetsData); // old way
        })
        .catch(function (err) {
          console.log("Fetch Error :-S", err);
          that.targetsLoading = false;
        });
    },
    getLists() {
      let that = this;
      getFiles("file_type=text/plain") // // file_type=text/plain
        .then((data) => {
          that.lists = data.Records;
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    save() {
      this.submitForm("testform");
      // console.log(this.$refs["assetsTree"].getCheckedValues());
    },
  },
  computed: {
    computedTargetsFilter() {
      return this.targetsFilter;
    },
    scripts_list() {
      var items = [];
      for (var i in this.atoms) {
        items.push({
          label: this.atoms[i].title,
          value: this.atoms[i].atom_id,
        });
      }
      return items;
    },
    dataComputed() {
      return [
        {
          value: "inline",
          label: "Inline",
          children: [
            {
              value: "list",
              label: "List",
            },
          ],
        },
        {
          value: "generator",
          label: "Generators",
          children: [
            {
              // generator/randomstring
              value: "randomstring",
              label: "Random string",
            },
            {
              value: "numbers",
              label: "Numbers",
            },
            {
              value: "chars",
              label: "Chars",
            },
          ],
        },
        {
          value: "file",
          label: "Lines from file",
          children: this.listsComputed,
        },
      ];
    },
    listsComputed() {
      var items = [];
      for (var i in this.lists) {
        items.push({ label: this.lists[i].file_name, value: this.lists[i].id });
      }
      return items;
    },
    topLevelFilter: {
      get: function () {
        return this.loadAssets;
      },
      set: function (v) {
        this.loadAssets = v;
        this.loadTargets();
      },
    },
  },
};
</script>

<style scoped>
.block33 {
  display: table;
  color: #8492a6;
}

.el-input {
  margin-top: 5px;
}

.mrg {
  margin-top: 5px;
}

/* max-height - the only parameter in this file that needs to be edited.
 * Change it to suit your needs. The rest is recommended to leave as is.
 */
.clusterize-scroll {
  max-height: 200px;
  overflow: auto;
}

/**
 * Avoid vertical margins for extra tags
 * Necessary for correct calculations when rows have nonzero vertical margins
 */
.clusterize-extrel-row {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

/* By default extra tag .clusterize-keep-parity added to keep parity of rows.
 * Useful when used :nth-child(even/odd)
 */
.clusterize-extrel-row.clusterize-keep-parity {
  display: none;
}

/* During initialization clusterize adds tabindex to force the browser to keep focus
 * on the scrolling list, see issue #11
 * Outline removes default browser's borders for focused elements.
 */
.clusterize-content {
  outline: 0;
  counter-reset: clusterize-counter;
}

/* Centering message that appears when no data provided
 */
.clusterize-no-data td {
  text-align: center;
}
</style>
<style>
#example_paginate,
#example_length {
  display: none !important;
}

.head-title {
  font-size: 20px;
  font-weight: 400;
  display: inline-block;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
    Microsoft YaHei, \\5fae\8f6f\96c5\9ed1, Arial, sans-serif;
  font-size: 14px;
  line-height: 1.5;
  color: #515a6e;
  background-color: #fff;
  -webkit-font-smoothing: antialiased;
}

.dts_label {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/NewTask.vue